<template>
  <div>
    <label>Palavras-chave</label>
    <b-form-tags
        v-model="innerValue"
        tag-pills
        :disabled="status === 'sending' || disabled"
        add-button-text="Adicionar"
        duplicate-tag-text="Tag duplicada"
        placeholder=""
        style="min-height: 60px"
    ></b-form-tags>

  </div>

</template>
<script>
export default {
  name: 't-keyword',
  data() {
    return {
      innerValue: [],
    }
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: "",
    },
    command: {
      type: String,
      default: "insert",
    },
  },
  mounted() {
    this.setValue(this.value)
  },
  methods: {
    setValue(v) {
      this.innerValue = v
    }
  },
  watch: {

    value(v) {
      this.setValue(v)
    },
    innerValue(value) {
      this.$emit("input", value)
    }
  }
}
</script>
<style>
</style>